import React, { useState } from 'react';
import './Tictactoe.css';

const Tictactoe = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [xIsNext, setXIsNext] = useState(true);

  const handleClick = (index) => {
    const boardCopy = [...board];
    if (boardCopy[index] || calculateWinner(boardCopy)) return;
    boardCopy[index] = xIsNext ? 'X' : 'O';
    setBoard(boardCopy);
    setXIsNext(!xIsNext);
  };
  const openUrl = () => {
    window.open('https://draftj.in', '_blank');
}

  const calculateWinner = (squares) => {
    const lines = [
      [0, 1, 2], [3, 4, 5], [6, 7, 8],
      [0, 3, 6], [1, 4, 7], [2, 5, 8],
      [0, 4, 8], [2, 4, 6]
    ];
    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
        return squares[a];
      }
    }
    return null;
  };

  const winner = calculateWinner(board);
  const status = winner ? `Winner: ${winner}` : `Next player: ${xIsNext ? 'X' : 'O'}`;

  return (
    <div className="game">
       <button onClick={openUrl}>Home</button>
      <div className="game-board">
        {board.map((value, index) => (
          <button className="square" onClick={() => handleClick(index)} key={index}>
            {value}
          </button>
        ))}
      </div>
      <div className="game-info">{status}</div>
    </div>
  );
};

export default Tictactoe;